export default {"src":"/_next/static/image/public/images/ic_upload_blue.26d6058ec16f1b72b35440cb756c5616.svg","height":20,"width":20};